export default __webpack_public_path__ + "static/media/slot5.941d8a7a.png";